(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-tyohaar"]) return;
  try {
    
  /*
   * Self-contained header behaviour: drawer, search overlay, sticky.
   * Intentionally does not extend Dawn's MenuDrawer / DetailsModal so the
   * header carries no dependency on Dawn's header markup or CSS.
   */
  class TyohHeader extends HTMLElement {
    connectedCallback() {
      this.openPanel = null;
      this.lastFocus = null;

      this.onClick = this.onClick.bind(this);
      this.onKeydown = this.onKeydown.bind(this);
      this.addEventListener('click', this.onClick);
      document.addEventListener('keydown', this.onKeydown);

      if (this.dataset.sticky) this.initSticky();
      this.setHeight();
      this.resizeObserver = new ResizeObserver(() => this.setHeight());
      this.resizeObserver.observe(this);
    }

    disconnectedCallback() {
      document.removeEventListener('keydown', this.onKeydown);
      this.resizeObserver?.disconnect();
      window.removeEventListener('scroll', this.onScroll);
      document.body.classList.remove('tyoh-locked');
    }

    setHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.offsetHeight}px`);
    }

    onClick(event) {
      const opener = event.target.closest('[data-tyoh-open]');
      if (opener) {
        event.preventDefault();
        this.open(opener.dataset.tyohOpen, opener);
        return;
      }

      if (event.target.closest('[data-tyoh-close]')) {
        event.preventDefault();
        this.close();
        return;
      }

      const toggle = event.target.closest('[data-tyoh-toggle]');
      if (toggle) {
        event.preventDefault();
        const group = toggle.closest('.tyoh__panel-group');
        const expanded = group.classList.toggle('is-expanded');
        toggle.setAttribute('aria-expanded', expanded);
      }
    }

    onKeydown(event) {
      if (!this.openPanel) return;
      if (event.key === 'Escape') {
        this.close();
        return;
      }
      if (event.key !== 'Tab') return;

      // Keep focus inside the open panel.
      const focusable = this.openPanel.querySelectorAll(
        'a[href], button:not([disabled]), input:not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])'
      );
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    open(name, opener) {
      const panel = this.querySelector(`.tyoh__panel--${name}, .tyoh__${name}-panel`);
      const scrim = this.querySelector(`.tyoh__scrim--${name}`);
      if (!panel) return;

      this.lastFocus = opener || document.activeElement;
      this.openPanel = panel;
      panel.hidden = false;
      if (scrim) scrim.hidden = false;

      // Next frame so the transition runs from the hidden state.
      requestAnimationFrame(() => this.classList.add(`is-open-${name}`));

      opener?.setAttribute('aria-expanded', 'true');
      // The scrollbar's width, measured rather than assumed — it differs by
      // machine. Held as padding while locked so the page does not shift
      // sideways the moment the bar disappears.
      const bar = window.innerWidth - document.documentElement.clientWidth;
      document.documentElement.style.setProperty('--tyoh-scrollbar', `${bar}px`);
      document.body.classList.add('tyoh-locked');
      // The counted lock as well: it stops smooth scrolling (Lenis), which
      // otherwise keeps moving the page behind the drawer from the wheel.
      // Menu only: the search panel's results scroll, and a stopped Lenis would block that.
      if (name === 'menu') window.tyohScrollLock?.lock(panel);

      const target = panel.querySelector('input:not([type="hidden"]), a[href], button');
      (target || panel).focus({ preventScroll: true });
    }

    close() {
      if (!this.openPanel) return;
      const panel = this.openPanel;
      const name = panel.classList.contains('tyoh__panel--menu') ? 'menu' : 'search';
      const scrim = this.querySelector(`.tyoh__scrim--${name}`);

      this.classList.remove(`is-open-${name}`);
      this.querySelectorAll('[data-tyoh-open]').forEach((el) => el.setAttribute('aria-expanded', 'false'));
      this.openPanel = null;

      const finish = () => {
        panel.hidden = true;
        if (scrim) scrim.hidden = true;
        // Unlocked here, not above. Releasing the lock while the panel is
        // still sliding puts the scrollbar back mid-animation and the whole
        // page jumps wider by its width — which reads as the drawer closing
        // from the full width of the screen rather than from its own edge.
        document.body.classList.remove('tyoh-locked');
        document.documentElement.style.removeProperty('--tyoh-scrollbar');
        window.tyohScrollLock?.release(panel);
      };
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        finish();
      } else {
        panel.addEventListener('transitionend', finish, { once: true });
        // Longer than the slowest close the settings allow, so this only ever
        // catches a transitionend that never fired — it must not cut a close short.
        setTimeout(finish, 900);
      }

      this.lastFocus?.focus({ preventScroll: true });
      this.lastFocus = null;
    }

    initSticky() {
      let last = 0;
      this.onScroll = () => {
        if (this.openPanel) return;
        const y = window.scrollY;
        if (this.dataset.sticky === 'scroll-up') {
          const past = y > this.offsetHeight;
          this.classList.toggle('is-hidden', past && y > last);
        }
        last = y;
      };
      window.addEventListener('scroll', this.onScroll, { passive: true });
    }
  }

  if (!customElements.get('tyoh-header')) customElements.define('tyoh-header', TyohHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  /*
    One small enhancement over Dawn's collection markup. It owns no state and
    touches no filter: the density switch only changes how many cards sit per
    row. Everything to do with price is server-rendered Liquid.
  */

  class GridDensity extends HTMLElement {
    connectedCallback() {
      this.root = document.querySelector(this.dataset.target);
      if (!this.root) return;

      this.key = 'tyo-density:' + this.dataset.target;
      this.buttons = Array.from(this.querySelectorAll('[data-density]'));
      this.buttons.forEach((btn) =>
        btn.addEventListener('click', () => this.apply(btn.dataset.density, true))
      );

      let saved = null;
      try {
        saved = localStorage.getItem(this.key);
      } catch (e) {
        /* private window, or site data blocked — fall through to the default */
      }
      this.apply(saved === 'compact' ? 'compact' : 'roomy', false);
    }

    apply(mode, persist) {
      const columns = mode === 'compact' ? this.dataset.compact : this.dataset.roomy;
      this.root.style.setProperty('--col-cards', columns);
      this.buttons.forEach((btn) =>
        btn.setAttribute('aria-pressed', String(btn.dataset.density === mode))
      );

      if (!persist) return;
      try {
        localStorage.setItem(this.key, mode);
      } catch (e) {
        /* not being able to remember the choice is not a reason to break it */
      }
    }
  }

  if (!customElements.get('grid-density')) customElements.define('grid-density', GridDensity);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  /* Mobile position dots + the media counter chip.
     The stage is a scroll-snap slider (Dawn's SliderComponent) which already
     emits `slideChanged`, so on mobile we just mirror that. On desktop the
     stage doesn't scroll — thumbnails swap the active media — so we also read
     the position off the clicked thumbnail's data-media-position. */
  class GalleryDots extends HTMLElement {
    connectedCallback() {
      this.viewer = this.closest('slider-component');
      this.gallery = this.closest('media-gallery');
      this.dots = Array.from(this.querySelectorAll('.gallery-dots__dot'));
      if (!this.viewer) return;

      this.counter = this.gallery?.querySelector('[data-gallery-counter-current]');

      this.viewer.addEventListener('slideChanged', (event) => {
        this.setActive(event.detail.currentPage - 1);
      });

      this.gallery?.addEventListener('click', (event) => {
        const item = event.target.closest('[data-media-position]');
        if (item) this.setActive(parseInt(item.dataset.mediaPosition, 10) - 1);
      });

      this.bindDots();
    }

    bindDots() {
      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
          // Visible slides only — the colour filter hides other colours' slides.
          const slide = Array.from(this.viewer.querySelectorAll('[id^="Slide-"]')).filter(
            (item) => !item.classList.contains('media-color-off')
          )[index];
          if (slide) slide.parentElement.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
        });
      });
    }

    /* One dot per visible slide, after the colour filter changes how many
       there are. Rebuilt from the first dot so the markup stays the theme's. */
    rebuild(count) {
      const template = this.dots[0];
      if (!template) return;
      const fresh = Array.from({ length: Math.max(count, 0) }, (_, i) => {
        const dot = template.cloneNode(true);
        dot.setAttribute('aria-label', template.getAttribute('aria-label').replace(/\d+/, i + 1));
        return dot;
      });
      this.dots.forEach((dot) => dot.remove());
      this.append(...fresh);
      this.dots = fresh;
      this.classList.toggle('gallery-dots--empty', count < 2);
      this.bindDots();
      this.setActive(0);
    }

    setActive(index) {
      if (Number.isNaN(index) || index < 0) return;

      this.dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === index);
        dot.setAttribute('aria-current', i === index ? 'true' : 'false');
      });

      if (this.counter) this.counter.textContent = index + 1;
    }
  }

  if (!customElements.get('gallery-dots')) customElements.define('gallery-dots', GalleryDots);

  /* Colour filter by alt text — see snippets/product-media-gallery.liquid.
     An image whose alt is one of the product's option values shows only while
     that value is selected; any other image always shows. Runs on the option
     change itself (instant) and again once Dawn's re-render has reordered the
     slides, then refreshes thumbnails, counter, dots and both sliders. */
  class MediaColorFilter extends HTMLElement {
    connectedCallback() {
      this.gallery = this.closest('media-gallery');
      this.productInfo = this.closest('product-info');
      if (!this.gallery) return;
      this.keys = new Set((this.dataset.keys || '').split('|').filter(Boolean));

      this.onChange = (event) => {
        if (event.target.closest('variant-selects')) this.apply(this.selectedFromPicker());
      };
      this.productInfo?.addEventListener('change', this.onChange);

      // pubsub.js is deferred; hook up once it exists.
      const hook = () => {
        if (this.unsubscribe || typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const variant = event?.data?.variant;
          if (!variant || event.data.sectionId !== this.productInfo?.dataset.section) return;
          this.apply(variant.options);
        });
      };
      hook();
      if (!this.unsubscribe) window.addEventListener('DOMContentLoaded', hook, { once: true });

      this.apply(this.selectedFromPicker());
    }

    disconnectedCallback() {
      this.productInfo?.removeEventListener('change', this.onChange);
      this.unsubscribe?.();
    }

    selectedFromPicker() {
      return (
        this.productInfo
          ?.querySelector('variant-selects')
          ?.getAllSelectedOptions?.()
          .map((option) => option.value) || []
      );
    }

    apply(values) {
      if (!values?.length) return;
      const selected = new Set(values.map((value) => String(value).toLowerCase().trim()));
      const items = Array.from(this.gallery.querySelectorAll('li[data-media-alt]'));
      const hit = items.some((item) => selected.has(item.dataset.mediaAlt));

      items.forEach((item) => {
        const alt = item.dataset.mediaAlt;
        item.classList.toggle('media-color-off', hit && this.keys.has(alt) && !selected.has(alt));
      });

      const visible = (selector) =>
        Array.from(this.gallery.querySelectorAll(selector)).filter(
          (item) => !item.classList.contains('media-color-off')
        );

      // Thumbnails number 1..n among what is shown — the counter reads it.
      visible('.thumbnail-list > li[data-media-position]').forEach((item, i) => {
        item.dataset.mediaPosition = i + 1;
      });

      const slides = visible('.product__media-list > li[data-media-id]');
      const total = this.gallery.querySelector('[data-gallery-counter-total]');
      if (total) total.textContent = slides.length;
      this.gallery.querySelector('gallery-dots')?.rebuild?.(slides.length);

      // The shown picture must be one of this colour's.
      const active = this.gallery.querySelector('.product__media-list > li.is-active');
      if ((!active || active.classList.contains('media-color-off')) && slides[0]) {
        this.gallery.setActiveMedia?.(slides[0].dataset.mediaId, false);
      }

      this.gallery.querySelectorAll('slider-component').forEach((slider) => {
        slider.querySelector('.slider')?.scrollTo({ left: 0 });
        if (slider.resetPages) slider.resetPages();
      });
    }
  }

  if (!customElements.get('media-color-filter')) customElements.define('media-color-filter', MediaColorFilter);

  /* Swaps the gallery image the moment an option changes, rather than waiting
     for Dawn's section re-render to come back over the network. Listens to the
     plain change event so it has no dependency on pubsub having loaded yet.
     Dawn's own updateMedia still runs afterwards and resolves to the same
     media, so this only removes the wait — it does not replace the logic. */
  class VariantMediaSwap extends HTMLElement {
    connectedCallback() {
      this.productInfo = this.closest('product-info');
      if (!this.productInfo) return;

      try {
        this.variants = JSON.parse(this.querySelector('script[type="application/json"]').textContent);
      } catch {
        this.variants = [];
      }
      if (!this.variants.length) return;

      this.onChange = this.onChange.bind(this);
      this.productInfo.addEventListener('change', this.onChange);
    }

    disconnectedCallback() {
      this.productInfo?.removeEventListener('change', this.onChange);
    }

    onChange(event) {
      if (!event.target.closest('variant-selects')) return;

      const selects = this.productInfo.querySelector('variant-selects');
      const chosen = selects?.getAllSelectedOptions?.().map((option) => option.value);
      if (!chosen?.length) return;

      const match = this.variants.find(
        (variant) =>
          variant.options.length === chosen.length && variant.options.every((value, i) => value === chosen[i])
      );
      if (!match?.media_id) return;

      this.productInfo
        .querySelector('media-gallery')
        ?.setActiveMedia?.(`${this.productInfo.dataset.section}-${match.media_id}`, true);
    }
  }

  if (!customElements.get('variant-media-swap')) customElements.define('variant-media-swap', VariantMediaSwap);

  /* Sticky add-to-bag bar.
     Adds nothing to the cart itself — the button carries form="product-form-x",
     so clicking it submits the real product form and Dawn's <product-form>
     handler does the work. This class only decides when the bar is visible and
     mirrors the two things that change underneath it: the current price and the
     submit button's disabled state. Both are read straight off the live DOM via
     MutationObserver, so no theme file needs a new hook and a variant change
     that arrives from anywhere keeps the bar honest. */
  class StickyAtc extends HTMLElement {
    connectedCallback() {
      const sectionId = this.dataset.section;

      this.label = this.dataset.label || '';
      this.button = this.querySelector('[data-sticky-submit]');
      this.buttonText = this.querySelector('[data-sticky-submit-text]');
      this.spinner = this.querySelector('.loading__spinner');
      this.priceTarget = this.querySelector('[data-sticky-price]');
      this.imageTarget = this.querySelector('[data-sticky-image]');

      this.mainButton = document.getElementById(`ProductSubmitButton-${sectionId}`);
      this.mainPrice = document.getElementById(`price-${sectionId}`);
      this.header = document.querySelector('.tyoh--sticky');

      this.syncButton();
      this.syncPrice();
      this.syncImage();

      /* The gallery is the source for the thumbnail, so it is what has to be
         watched — a variant change reaches the bar through it, not through the
         price node. class carries .is-active as the slide changes; src covers
         the case where the section re-renders the same slide with a new
         picture. */
      const gallery = document.getElementById(`GalleryViewer-${sectionId}`);
      if (gallery && this.imageTarget) {
        this.imageObserver = new MutationObserver(() => this.syncImage());
        this.imageObserver.observe(gallery, {
          attributes: true,
          attributeFilter: ['class', 'src', 'srcset'],
          childList: true,
          subtree: true,
        });
      }

      if (this.mainButton) {
        this.buttonObserver = new MutationObserver(() => this.syncButton());
        this.buttonObserver.observe(this.mainButton, {
          attributes: true,
          /* class carries .loading and aria-disabled marks the in-flight
             request — both are set by Dawn on the main button only. */
          attributeFilter: ['disabled', 'class', 'aria-disabled'],
          childList: true,
          characterData: true,
          subtree: true,
        });
      }

      if (this.mainPrice) {
        this.priceObserver = new MutationObserver(() => this.syncPrice());
        this.priceObserver.observe(this.mainPrice, { childList: true, characterData: true, subtree: true });
      }

      /* Only the top position has to dodge the header; a bottom bar is pinned
         to the viewport floor and never meets it. */
      if (this.header && this.dataset.position === 'top') this.trackHeader();

      /* In the theme editor the merchant has to be able to see the block they
         just selected, so skip the scroll trigger and pin it open. */
      if (this.dataset.designMode) {
        this.classList.add('is-visible');
        return;
      }

      this.watchTrigger();
    }

    disconnectedCallback() {
      this.buttonObserver?.disconnect();
      this.priceObserver?.disconnect();
      this.imageObserver?.disconnect();
      this.triggerObserver?.disconnect();
      this.footerObserver?.disconnect();
      if (this.onScroll) window.removeEventListener('scroll', this.onScroll);
      if (this.updateOffset) window.removeEventListener('resize', this.updateOffset);
    }

    /* Show once the real button has left the top of the viewport. Checking
       boundingClientRect.top matters: isIntersecting is also false while the
       button is still below the fold on first paint, and the bar must stay
       hidden then. */
    watchTrigger() {
      const target = this.mainButton || this.closest('product-info')?.querySelector('.product-form__buttons');
      if (!target) return;

      this.triggerObserver = new IntersectionObserver(([entry]) => {
        this.pastButton = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        this.render();
      });
      this.triggerObserver.observe(target);

      this.watchFooter();
    }

    /* RETREAT AT THE FOOTER.

       The bar is position: fixed, so it floats over whatever is underneath —
       including the footer, which is the one place on the page it has no
       business covering. By the time someone has reached the footer they have
       scrolled past the product and are reading links; a buy button pinned
       over the newsletter field is in the way, not helpful.

       AN OBSERVER, NOT A SCROLL HANDLER. The browser works out the
       intersection off the main thread and tells us only when the answer
       changes — a scroll listener would run on every frame and measure the
       footer each time, which is the same answer computed hundreds of times
       for the handful of moments it differs.

       rootMargin pulls the trigger line UP by the bar's own height, so the
       retreat starts as the footer reaches where the bar sits rather than
       where the viewport ends. Without it the bar is still covering the first
       strip of footer at the moment it decides to leave, and the two overlap
       for the length of the animation. */
    watchFooter() {
      /* EVERY footer section, not the first one.

         The footer group is three separate sections — trust badges, the
         festival footer, the default footer — and Shopify wraps each in its
         own div rather than one container. querySelector returns the FIRST,
         which is the short trust-badges band at the very top of the group. The
         bar correctly hid when that band appeared, then came back the moment
         it scrolled off the top — sitting over the real footer for the whole
         rest of the page, which is precisely what it was meant to avoid.

         So all of them are watched and a Set holds whichever are on screen.
         Hidden while that set has anything in it, which stays true the whole
         way down regardless of which section is passing. */
      const parts = Array.from(
        document.querySelectorAll('.shopify-section-group-footer-group')
      );
      const targets = parts.length ? parts : [document.querySelector('footer')].filter(Boolean);
      if (!targets.length) return;

      const margin = Math.round(this.getBoundingClientRect().height) || 80;
      this.footerHits = new Set();

      this.footerObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            /* Height guard: only one of the two footers renders at a time, so
               the other leaves an empty wrapper behind. A zero-height div is
               reported as intersecting by some browsers and would pin the bar
               shut for the whole page. */
            const real = entry.isIntersecting && entry.boundingClientRect.height > 0;
            if (real) this.footerHits.add(entry.target);
            else this.footerHits.delete(entry.target);
          });

          this.atFooter = this.footerHits.size > 0;
          this.render();
        },
        { rootMargin: `0px 0px -${margin}px 0px` }
      );

      targets.forEach((part) => this.footerObserver.observe(part));
    }

    /* One place decides, so the two observers cannot contradict each other.
       Visible means: scrolled past the real button AND not yet at the footer.
       Written as a single toggle rather than each observer setting the class
       itself, which is how a bar ends up stuck open when the two fire in an
       order nobody predicted. */
    render() {
      this.classList.toggle('is-visible', Boolean(this.pastButton) && !this.atFooter);
    }

    /* The header is position: sticky and, in scroll-up mode, slides away
       exactly when this bar appears. Following its live bottom edge keeps the
       bar flush against it instead of leaving a strip of page showing. */
    trackHeader() {
      let ticking = false;

      this.updateOffset = () => {
        ticking = false;
        const bottom = this.header.getBoundingClientRect().bottom;
        this.style.setProperty('--tsb-top', `${Math.max(0, bottom)}px`);
      };

      this.onScroll = () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(this.updateOffset);
      };

      this.updateOffset();
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.updateOffset, { passive: true });
    }

    /* Mirror the disabled state, but not the label: Dawn writes "Add to cart"
       there, while this bar's wording is a block setting. Only borrow the text
       when the button is disabled, since that is the sold out / unavailable
       message. */
    syncButton() {
      if (!this.mainButton || !this.button) return;

      const disabled = this.mainButton.hasAttribute('disabled');
      this.button.disabled = disabled;

      /* Dawn adds .loading for the life of the add-to-cart request and clears
         it in its finally block, so mirroring it gives the sticky button the
         same spinner without duplicating any of the fetch logic. */
      const loading = this.mainButton.classList.contains('loading');
      this.button.classList.toggle('loading', loading);
      this.button.setAttribute('aria-disabled', loading ? 'true' : 'false');
      this.spinner?.classList.toggle('hidden', !loading);

      if (!this.buttonText) return;
      const mainText = this.mainButton.querySelector('span')?.textContent.trim();
      this.buttonText.textContent = disabled && mainText ? mainText : this.label;
    }

    /* Dawn always renders both branches and hides one, so read whichever the
       price--on-sale class puts in play rather than the first match. */
    /* The thumbnail follows the gallery, not the variant data.

       Reading variant.featured_image would mean this class knowing how a
       variant maps to a picture — which Dawn, variant-media-swap and the
       section render all already decide between them, and sometimes disagree
       about mid-request. The gallery's active slide is the one answer all of
       them converge on, so it is the one worth mirroring.

       Silently does nothing when the gallery has no active image: a bar
       showing the previous product's picture would be worse than one showing
       the first. */
    syncImage() {
      if (!this.imageTarget) return;

      const gallery = document.getElementById(`GalleryViewer-${this.dataset.section}`);
      /* .is-active is the slide the gallery considers current; the bare img is
         the fallback for the first paint, before any slide has been marked. */
      const active = gallery?.querySelector('.is-active img') || gallery?.querySelector('img');
      if (!active?.currentSrc && !active?.src) return;

      const next = active.currentSrc || active.src;
      if (next === this.imageTarget.currentSrc || next === this.imageTarget.src) return;

      /* srcset has to go with it — left in place the browser would keep
         choosing a candidate from the OLD set and the swap would not stick. */
      this.imageTarget.removeAttribute('srcset');
      this.imageTarget.src = next;
    }

    syncPrice() {
      if (!this.mainPrice || !this.priceTarget) return;

      const price = this.mainPrice.querySelector('.price');
      if (!price) return;

      const current = price.classList.contains('price--on-sale')
        ? price.querySelector('.price__sale .price-item--sale')
        : price.querySelector('.price__regular .price-item--regular');

      const text = current?.textContent.trim();
      if (text) this.priceTarget.textContent = text;
    }
  }

  if (!customElements.get('sticky-atc')) customElements.define('sticky-atc', StickyAtc);

  /* Keeps the stock note in step with the selected variant.
     Dawn's product-info.js refreshes only a fixed list of elements after a
     variant change (price, Sku, Inventory, Volume, Price-Per-Item), so anything
     added to the section keeps its page-load content forever — which is why the
     note kept showing the first colour's sold-out packs after switching colour.
     The re-rendered section arrives on the variantChange event, so take the
     fresh markup from there. */
  class StockNoteUpdater extends HTMLElement {
    connectedCallback() {
      if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

      this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        const html = event?.data?.html;
        if (!html) return;

        const fresh = html.getElementById(this.id);
        // A missing node means the new selection has nothing to report, so
        // clear it rather than leave the previous colour's notes behind.
        this.innerHTML = fresh ? fresh.innerHTML.trim() : '';
      });
    }

    disconnectedCallback() {
      this.unsubscribe?.();
    }
  }

  if (!customElements.get('stock-note-updater')) customElements.define('stock-note-updater', StockNoteUpdater);

  /* Pincode serviceability, resolved entirely in the theme.
     A courier API cannot be called from here — the key would be public — so
     this matches the pincode against prefix rules the merchant types in the
     block. Longest prefix wins, so "110" beats "11". Swap the resolve() body
     for a fetch to your own proxy later and nothing else has to change. */
  class PincodeCheck extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('.product__pincode-input');
      this.button = this.querySelector('.product__pincode-button');
      this.result = this.parentElement?.querySelector('.product__pincode-result');
      if (!this.input || !this.button) return;

      this.length = parseInt(this.dataset.length, 10) || 6;
      this.rules = this.parseRules(this.dataset.rules);
      this.blocked = (this.dataset.blocked || '')
        .split(/[\s,]+/)
        .map((p) => p.trim())
        .filter(Boolean);

      this.button.addEventListener('click', () => this.check());
      this.input.addEventListener('keydown', (event) => {
        if (event.key === 'Enter') {
          event.preventDefault();
          this.check();
        }
      });

      this.remember = this.dataset.remember === 'true';

      // Off by default: the field starts empty on every load. Turn the setting
      // on to carry the last pincode across pages and refreshes instead.
      if (!this.remember) {
        try {
          localStorage.removeItem('tyohaar:pincode');
        } catch {
          /* private mode — skip silently */
        }
        return;
      }

      try {
        const saved = localStorage.getItem('tyohaar:pincode');
        if (saved) {
          this.input.value = saved;
          this.check(true);
        }
      } catch {
        /* private mode — skip silently */
      }
    }

    // "39:2-3" per line. Also accepts "39: 2-3" and comma separators.
    parseRules(raw) {
      return (raw || '')
        .split(/[\r\n,]+/)
        .map((line) => line.trim())
        .filter(Boolean)
        .map((line) => {
          const [prefix, range] = line.split(':').map((part) => (part || '').trim());
          if (!prefix || !range) return null;
          const [min, max] = range.split('-').map((n) => parseInt(n, 10));
          if (Number.isNaN(min)) return null;
          return { prefix, min, max: Number.isNaN(max) ? min : max };
        })
        .filter(Boolean)
        .sort((a, b) => b.prefix.length - a.prefix.length);
    }

    resolve(pincode) {
      if (this.blocked.some((prefix) => pincode.startsWith(prefix))) return null;
      const match = this.rules.find((rule) => pincode.startsWith(rule.prefix));
      return {
        min: match ? match.min : parseInt(this.dataset.defaultMin, 10) || 0,
        max: match ? match.max : parseInt(this.dataset.defaultMax, 10) || 0,
      };
    }

    formatWindow(min, max) {
      const day = 86400000;
      const start = new Date(Date.now() + min * day);
      const end = new Date(Date.now() + max * day);
      const month = (d) => d.toLocaleDateString(undefined, { month: 'long' });
      // Repeat the month only when the window crosses one.
      return month(start) === month(end)
        ? `${start.getDate()}–${end.getDate()} ${month(end)}`
        : `${start.getDate()} ${month(start)} – ${end.getDate()} ${month(end)}`;
    }

    show(message, state) {
      if (!this.result) return;
      this.result.textContent = message;
      this.result.dataset.state = state;
    }

    check(silent) {
      const pincode = (this.input.value || '').replace(/\D/g, '');

      if (pincode.length !== this.length) {
        if (!silent) this.show(this.dataset.invalidMessage, 'error');
        return;
      }

      if (this.remember) {
        try {
          localStorage.setItem('tyohaar:pincode', pincode);
        } catch {
          /* private mode — skip silently */
        }
      }

      const estimate = this.resolve(pincode);
      if (!estimate) {
        this.show((this.dataset.blockedMessage || '').replace('{pincode}', pincode), 'error');
        return;
      }

      const message = (this.dataset.success || '')
        .replace('{window}', this.formatWindow(estimate.min, estimate.max))
        .replace('{pincode}', pincode);
      this.show(message, 'ok');
    }
  }

  if (!customElements.get('pincode-check')) customElements.define('pincode-check', PincodeCheck);

  /* Smooth-scrolls to another section on the page.
     The inner <a href="#..."> already works on its own, so this only upgrades
     the instant jump into an animated one. If the target is missing the click
     is left alone and the browser handles it normally.
     Honours prefers-reduced-motion — an animated scroll is exactly the kind of
     movement people turn that setting on to avoid. */
  class ScrollToTarget extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', (event) => {
        const selector = this.dataset.target;
        if (!selector) return;

        const target = document.querySelector(selector);
        if (!target) return;

        event.preventDefault();

        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });

        // Keep the URL and history consistent with a normal anchor click.
        if (window.history?.replaceState) {
          window.history.replaceState(null, '', selector);
        }
      });
    }
  }

  if (!customElements.get('scroll-to-target')) customElements.define('scroll-to-target', ScrollToTarget);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-reviews"] && !Shopify.designMode) return;
  try {
    
  class ReviewsMore extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-reviews-more]');
      if (this.button) {
        this.button.addEventListener('click', () => this.revealAll());
      }

      // In the theme editor a merchant can pick a review that is still hidden.
      // Shopify cannot scroll to a hidden element, so open the list first.
      document.addEventListener('shopify:block:select', (event) => {
        if (this.contains(event.target)) this.revealAll();
      });
    }

    revealAll() {
      this.querySelectorAll('.reviews__item--hidden').forEach((item) => {
        item.hidden = false;
        item.classList.remove('reviews__item--hidden');
      });

      // Nothing left behind the button, so it has no job any more.
      if (this.button) this.button.remove();
    }
  }

  if (!customElements.get('reviews-more')) {
    customElements.define('reviews-more', ReviewsMore);
  }

  } catch(e) { console.error(e); }
})();
})();
